import React from "react";
import { connect } from "react-redux";
import { Icon, Input, Button } from "antd";
import { compose } from "recompose";
import { useTranslation } from "react-i18next";
import { Form, FormItem } from "@worcket/common/components/controls";
import { withForm, isLoading } from "@worcket/common/hocs";

import Centered from "../../components/display/Centered";
import {
  sendRecoverPasswordEmail,
  SEND_RECOVER_PASSWORD_EMAIL
} from "../../store/actions/session";
import logo from "../../assets/logo-black.svg";

import styled from "styled-components/macro";

const Container = styled(Form)`
  width: 300px;

  .logo {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;

    img {
      max-width: 160px;
    }
  }

  .recover-password-btn {
    width: 100%;
  }

  .success-alert {
    margin-top: 16px;
  }
`;

const PasswordRecoveryEmail = ({ form, onSubmit, loading }) => {
  const { t } = useTranslation();
  return (
    <Centered>
      <Container onSubmit={onSubmit}>
        <div className="logo">
          <img src={logo} alt="Worcket" />
        </div>
        <p>{t("components:PasswordRecoveryEmail.description")}</p>

        <FormItem
          form={form}
          name="email"
          rules={[
            { type: "email", message: t("auth:recoveryPassword.errorEmail") },
            { required: true, message: t("auth:recoveryPassword.emptyEmail") }
          ]}
          render={
            <Input
              disabled={loading}
              prefix={<Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder={t("auth:recoveryPassword.placeholderEmail")}
            />
          }
        />
        <Button
          loading={loading}
          className="recover-password-btn"
          size="large"
          type="primary"
          htmlType="submit"
        >
          {t("components:PasswordRecoveryEmail.button")}
        </Button>
      </Container>
    </Centered>
  );
};

const enhancer = compose(
  connect(
    undefined,
    { sendRecoverPasswordEmail }
  ),
  isLoading(SEND_RECOVER_PASSWORD_EMAIL),
  withForm({
    onSubmit: async (values, { sendRecoverPasswordEmail }) => {
      await sendRecoverPasswordEmail(values.email);
    }
  })
);

export default enhancer(PasswordRecoveryEmail);
